import { TMicroservicesState, TAction, actionTypes } from './types'

export const initialState: TMicroservicesState = {}

export default (state: TMicroservicesState = initialState, action: TAction) => {
  switch (action.type) {
    case actionTypes.SET_MICROSERVICES:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
